import { Component, OnInit, Input, SimpleChanges, ViewChild, forwardRef } from '@angular/core';
import { 
    IonGrid, IonRow, IonCol, IonSpinner, InfiniteScrollCustomEvent, IonInfiniteScroll,  IonInfiniteScrollContent 
} from '@ionic/angular/standalone';
import { TranslatePipe } from '@ngx-translate/core';
import moment from 'moment';

import { MarvCircleComponent, MarvMessageComponent, MarvDrawerComponent } from '@marv/components';
import { MissionItem, MissionItemComponent, MissionDetailsComponent, MissionDetailsTab } from '@app/components';
import { OrderService, OperationService } from '@app/services';

@Component({
    selector: 'app-mission-to-evaluate',
    templateUrl: './to-evaluate.component.html',
    styleUrls: ['./to-evaluate.component.scss'],
    imports: [
        IonGrid, IonRow, IonCol, IonInfiniteScroll, IonInfiniteScrollContent, IonSpinner, TranslatePipe, 
        forwardRef(() => MarvCircleComponent), forwardRef(() => MarvMessageComponent), forwardRef(() => MarvDrawerComponent), 
        forwardRef(() => MissionItemComponent), forwardRef(() => MissionDetailsComponent)
    ]
})
export class MissionToEvaluateComponent  implements OnInit {

    @Input({alias : 'typesMissions', required : false}) typesMissions: Array<string> = [];

    @ViewChild('drawerMissionDetails') drawerMissionDetails: MarvDrawerComponent;

    isFetching: boolean = false;
    missionsItems: Array<MissionItem> = [];
    missionsItemsToDisplay: Array<MissionItem> = [];
    missionsItemsDisplayed: Array<MissionItem> = []; 
    maxMissionsDisplayed: number = 50;
    indexMissionDisplayed: number = 0;
    disabledInfiniteScroll: boolean = false;
    
    missionItemSelected: MissionItem|null = null;     
    missionDetailsTab: MissionDetailsTab = 'infos';
    
    constructor(
        private orderService: OrderService
    ) { }

    async ngOnInit() {
        await this.loadsMissions();
    }

    ngOnChanges(changes: SimpleChanges) {
        if(changes['typesMissions']){
            this.setMissionsToDisplay();
        }
    }
    
    async loadsMissions(){
        this.isFetching = true;        
        let startDate = moment().subtract(10, 'days');
        let endDate = moment().subtract(1, 'days');
        let report = await this.orderService.loadToEvaluate(startDate.toDate(), endDate.toDate());
        if(report){            
            this.missionsItems = report.getMissionsItems(OperationService.OperationsSettings).filter(m => {
                return m.source === 'loga';
            });
            this.setMissionsToDisplay();            
        }
        this.isFetching = false;
    }
        
    setMissionsToDisplay(){
        if(this.typesMissions.length > 0){
            this.missionsItemsToDisplay = this.missionsItems.filter(m => 
                (m.operation && this.typesMissions.indexOf(m.operation?.typeOfMission) !== -1)
            );
        }
        else{
            this.missionsItemsToDisplay = this.missionsItems;
        }        
        this.missionsItemsDisplayed = [];
        this.indexMissionDisplayed = 0;
        this.disabledInfiniteScroll = false;
        this.getMissionsDisplayed();
    }
    
    getMissionsDisplayed() {
        let subArray = this.missionsItemsToDisplay.slice(this.indexMissionDisplayed, this.indexMissionDisplayed+this.maxMissionsDisplayed);
        if(subArray.length > 0){
            this.missionsItemsDisplayed = this.missionsItemsDisplayed.concat(subArray);
            this.indexMissionDisplayed += subArray.length;
        }
        else{
            this.disabledInfiniteScroll = true;
        }
    }
    
    onIonInfinite(event: InfiniteScrollCustomEvent) {        
        this.getMissionsDisplayed();
        event.target.complete();
    }
    
    onSelectMission(missionItem: MissionItem){
        this.missionItemSelected = missionItem;
        this.drawerMissionDetails.open();
    }
    
    onEvaluateMission(missionItem: MissionItem){
        this.missionDetailsTab = 'rating';
        this.missionItemSelected = missionItem;
        this.drawerMissionDetails.open();
    }

    onDidDismissDrawerMission($event: any){     
        this.missionDetailsTab = 'infos';   
        this.missionItemSelected = null;
    }
        
    async onUpdateMission(status: boolean){   
        if(status){ 
            await this.loadsMissions(); 
        }       
    }
    
    async onDeleteMission(status: boolean){
        if(status){
            this.drawerMissionDetails.close();
            await this.loadsMissions();
        }
    }
}
